import { css, useTheme } from "@emotion/react";
import { Children, forwardRef } from "react";

import useThemeProps from "./useThemeProps.jsx";

export default forwardRef(function ListStack(props, ref) {
  let {
    ordered = false,
    as: Component = ordered ? "ol" : "ul",
    children,
    direction = "column",
    spacing = 2,
    justifyContent = "center",
    divider = false,
    alignItems = "stretch",
    height = "auto",
    dividerStart = false,
    dividerEnd = false,
    ...restProps
  } = useThemeProps({
    props,
    name: "Stack",
  });
  const theme = useTheme();
  const gap = theme.getLength(spacing);

  if (divider === true) {
    divider = `1px solid ${theme.getColor("border")}`;
  }

  return (
    <Component
      ref={ref}
      css={css`
        display: flex;
        flex-direction: ${direction};
        justify-content: ${justifyContent};
        align-items: ${alignItems};
        height: ${theme.getLength(height)};
        list-style: none;
        padding: 0;
        margin: 0;
      `}
      {...restProps}
    >
      {Children.map(children, (child, index) => (
        <li
          css={css({
            [`padding${direction === "column" ? "BlockStart" : "InlineStart"}`]:
              index > 0 || dividerStart ? gap : undefined,
            [`padding${direction === "column" ? "BlockEnd" : "InlineEnd"}`]:
              divider && (index < children.length - 1 || dividerEnd)
                ? gap
                : undefined,
            [`border${direction === "column" ? "BlockStart" : "InlineStart"}`]:
              divider && index === 0 && dividerStart ? divider : undefined,
            [`border${direction === "column" ? "BlockEnd" : "InlineEnd"}`]:
              divider && (index < children.length - 1 || dividerEnd)
                ? divider
                : undefined,
          })}
          key={index}
        >
          {child}
        </li>
      ))}
    </Component>
  );
});
